// WAGE SUGGESTIONS - API
// =============================================================================
import { api } from "./constants/index";

export interface WageSuggestionResponse {
  status: 'SUCCESS' | 'ND' | 'ERROR';
  suggestedWage?: number;
  sampleSize: number;
  zipcode: string;
  jobType: string;
  fallbackLevel?: 'zipcode' | 'city' | 'state';
  location?: string;
  message?: string;
}

export const getWageSuggestion = ({
  zipcode,
  jobType,
  city,
  state
}: {
  zipcode: string;
  jobType: string;
  city?: string;
  state?: string;
}): Promise<WageSuggestionResponse> => {
  let url = `v2/wage_suggestions?zipcode=${zipcode}&jobType=${encodeURIComponent(jobType)}`;
  if (city) url += `&city=${encodeURIComponent(city)}`;
  if (state) url += `&state=${encodeURIComponent(state)}`;
  return api.get(url).json();
};
